import {Phone, Calendar, Shield, Sparkles, Car, Award, Check} from 'lucide-react'
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import CanonicalTag from '@/components/CanonicalTag'

const InteriorWrapTrimPage = () => {
  const navigate = useNavigate()

  return (
    <>
      <CanonicalTag url="https://autowrapsandiego.com/interior-wrap-trim" />
      <div className="pt-20 min-h-screen bg-black">
      {/* Hero */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-black text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl font-bold mb-6">Interior Wrap & Trim in San Diego</h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-4">
              Transform your vehicle's interior with professional interior wrap San Diego services. Our expert vinyl installations upgrade center consoles, dash trim, door panels, and custom accents to match your vision—from carbon fiber to gloss black finishes.
            </p>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">
              Serving North County San Diego including Vista, Carlsbad, and Oceanside, we specialize in interior trim wrap for luxury, performance, and Tesla vehicles. Protect and personalize your cabin with premium materials and flawless installation.
            </p>
            <div className="flex gap-4 justify-center">
              <a href="tel:858-282-8119" className="flex items-center gap-2 bg-cyan-500 hover:bg-cyan-600 text-white px-6 py-3 rounded-lg font-semibold transition">
                <Phone size={18} />
                858-282-8119
              </a>
              <button onClick={() => { navigate("/contact"); setTimeout(() => window.scrollTo(0, 0), 100); }} className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold transition">
                <Calendar size={18} />
                Book Consultation
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Interior Wrap Services */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-12 text-white text-center">Interior Wrap Services We Offer</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gray-900 p-8 rounded-xl border border-cyan-500/20">
              <h3 className="text-2xl font-bold mb-4 text-white">Center Console Wrap</h3>
              <p className="text-gray-300">Transform your center console with premium vinyl in carbon fiber, gloss black, or custom colors matching your interior theme.</p>
            </div>
            <div className="bg-gray-900 p-8 rounded-xl border border-cyan-500/20">
              <h3 className="text-2xl font-bold mb-4 text-white">Dashboard & Trim</h3>
              <p className="text-gray-300">Upgrade dashboard accents, air vent surrounds, and trim pieces for cohesive custom interior styling.</p>
            </div>
            <div className="bg-gray-900 p-8 rounded-xl border border-cyan-500/20">
              <h3 className="text-2xl font-bold mb-4 text-white">Door Trim & Piano Black Delete</h3>
              <p className="text-gray-300">Replace or cover piano black trim prone to scratches with durable vinyl finishes that maintain their appearance.</p>
            </div>
            <div className="bg-gray-900 p-8 rounded-xl border border-cyan-500/20">
              <h3 className="text-2xl font-bold mb-4 text-white">Custom Accents</h3>
              <p className="text-gray-300">Steering wheel trim, gear shift surrounds, speaker grilles, and custom interior accent pieces tailored to your vision.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Popular Finishes */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-12 text-white text-center">Popular Interior Finishes</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-black p-8 rounded-xl border border-cyan-500/20 text-center">
              <div className="bg-cyan-500/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto border border-cyan-500">
                <Sparkles className="text-cyan-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-white">Carbon Fiber</h3>
              <p className="text-gray-300">3D textured carbon fiber vinyl for authentic motorsport aesthetic and premium appearance.</p>
            </div>
            <div className="bg-black p-8 rounded-xl border border-cyan-500/20 text-center">
              <div className="bg-cyan-500/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto border border-cyan-500">
                <Shield className="text-cyan-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-white">Gloss Black</h3>
              <p className="text-gray-300">High-shine gloss black finish for modern, sleek interior styling popular on luxury vehicles.</p>
            </div>
            <div className="bg-black p-8 rounded-xl border border-cyan-500/20 text-center">
              <div className="bg-cyan-500/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto border border-cyan-500">
                <Car className="text-cyan-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-white">Satin & Matte</h3>
              <p className="text-gray-300">Non-reflective satin or matte finishes for subtle, refined interior upgrades with reduced glare.</p>
            </div>
            <div className="bg-black p-8 rounded-xl border border-cyan-500/20 text-center">
              <div className="bg-cyan-500/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto border border-cyan-500">
                <Award className="text-cyan-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-white">Brushed Metal</h3>
              <p className="text-gray-300">Metallic brushed aluminum or titanium look for performance-inspired interior detailing.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-12 text-white text-center">Why Choose Mr Wrap for Interior Wraps</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gray-900 p-8 rounded-xl border border-cyan-500/20">
              <div className="bg-cyan-500/20 w-16 h-16 rounded-full flex items-center justify-center mb-6 border border-cyan-500">
                <Award className="text-cyan-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-white">Clean Edges</h3>
              <p className="text-gray-300">Precision cutting and seamless application with clean edges and perfect alignment on all interior trim pieces.</p>
            </div>
            <div className="bg-gray-900 p-8 rounded-xl border border-cyan-500/20">
              <div className="bg-cyan-500/20 w-16 h-16 rounded-full flex items-center justify-center mb-6 border border-cyan-500">
                <Shield className="text-cyan-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-white">Quality Materials</h3>
              <p className="text-gray-300">Premium interior-grade vinyl from 3M and Avery designed for interior use with UV resistance and durability.</p>
            </div>
            <div className="bg-gray-900 p-8 rounded-xl border border-cyan-500/20">
              <div className="bg-cyan-500/20 w-16 h-16 rounded-full flex items-center justify-center mb-6 border border-cyan-500">
                <Sparkles className="text-cyan-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-white">Proper Prep</h3>
              <p className="text-gray-300">Thorough surface cleaning and preparation ensures maximum adhesion and professional results that last.</p>
            </div>
            <div className="bg-gray-900 p-8 rounded-xl border border-cyan-500/20">
              <div className="bg-cyan-500/20 w-16 h-16 rounded-full flex items-center justify-center mb-6 border border-cyan-500">
                <Car className="text-cyan-400" size={32} />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-white">Tesla & Luxury Experience</h3>
              <p className="text-gray-300">Extensive experience with Tesla interiors and luxury vehicle trim work requiring precision and care.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-12 text-white text-center">Interior Wrap FAQs</h2>
          <div className="space-y-6">
            <div className="bg-black p-6 rounded-xl border border-cyan-500/20">
              <h3 className="text-xl font-bold mb-3 text-white">Will interior wrap peel or bubble over time?</h3>
              <p className="text-gray-300">Quality interior vinyl installed with proper surface prep and professional techniques will not peel or bubble. We use interior-grade materials designed for cabin environments and ensure maximum adhesion through thorough cleaning and application methods.</p>
            </div>
            <div className="bg-black p-6 rounded-xl border border-cyan-500/20">
              <h3 className="text-xl font-bold mb-3 text-white">Does wrapping interior trim damage the original pieces?</h3>
              <p className="text-gray-300">No. Interior vinyl wrap actually protects your original trim from wear, scratches, and UV damage. When removed properly by professionals, the wrap comes off cleanly without residue or damage, preserving the factory finish underneath.</p>
            </div>
            <div className="bg-black p-6 rounded-xl border border-cyan-500/20">
              <h3 className="text-xl font-bold mb-3 text-white">How long does interior wrap installation take?</h3>
              <p className="text-gray-300">Most interior wrap projects take 4-8 hours depending on the number of pieces and complexity. Simple center console wraps can be completed in a few hours, while comprehensive interior transformations with multiple trim pieces may take a full day.</p>
            </div>
            <div className="bg-black p-6 rounded-xl border border-cyan-500/20">
              <h3 className="text-xl font-bold mb-3 text-white">Can interior wrap be removed if I change my mind?</h3>
              <p className="text-gray-300">Yes. Interior vinyl wrap is fully removable. Professional removal ensures the wrap comes off cleanly, allowing you to restore the original appearance or change to a different finish anytime without damaging your trim pieces.</p>
            </div>
            <div className="bg-black p-6 rounded-xl border border-cyan-500/20">
              <h3 className="text-xl font-bold mb-3 text-white">How do I clean wrapped interior trim?</h3>
              <p className="text-gray-300">Clean wrapped interior trim with mild soap and water using a soft microfiber cloth. Avoid harsh chemicals, abrasive cleaners, or rough materials that could scratch the vinyl. Regular dusting and gentle cleaning keeps interior wraps looking fresh.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-r from-cyan-500 to-cyan-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6 text-white">Ready to Upgrade Your Interior?</h2>
          <p className="text-xl text-white/90 mb-8">
            Schedule your free interior wrap consultation and quote
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button onClick={() => { navigate("/contact"); setTimeout(() => window.scrollTo(0, 0), 100); }} className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-12 rounded-lg transition-all transform hover:scale-105 shadow-xl inline-flex items-center justify-center gap-2">
              <Calendar size={20} />
              Book Consultation
            </button>
            <a href="tel:858-282-8119" className="bg-white hover:bg-gray-100 text-gray-900 font-bold py-4 px-12 rounded-lg transition-all transform hover:scale-105 shadow-xl inline-flex items-center justify-center gap-2">
              <Phone size={20} />
              Call: 858-282-8119
            </a>
          </div>
        </div>
      </section>
      </div>
    </>
  )
}

export default InteriorWrapTrimPage
